var WDN = WDN || {};

if (typeof WDN.RenderViewedProducts === "undefined") {
  WDN.RenderViewedProducts = (function () {
    class RenderViewedProducts {
      constructor(selector, list_selector, list) {
        this.selector = selector;
        this.list_selector = list_selector;
        this.viewedList = list || new ViewedProducts();
      }

      attachNodes() {
        this.container = document.querySelector(this.selector);
        this.productOutput = this.container.querySelector(this.list_selector);
        this.countOutputs = document.querySelectorAll("[data-recently-viewed-count]");
      }

      setupConfig() {
        this.productCardSectionName = this.container.getAttribute("data-recently-viewed-template") || "product-card";
        this.renderMax = this.container.getAttribute("data-recently-viewed-limit") || 20;
      }

      buildRenderableList() {
        this.renderableList = this.viewedList.list.reverse().slice(0, this.renderMax).reverse();
      }

      outputCount() {
        var count = this.viewedList.list.length;
        this.countOutputs.forEach(function (container) {
          container.setAttribute("data-recently-viewed-count", count);
          if (container.getAttribute("data-attribute-only") !== "") {
            container.innerHTML = count;
          }
        });
      }

      render() {
        // verify if we have a list length greater than 0, or set state on container
        if (this.renderableList.length == 0) {
          this.container.setAttribute("data-recently-viewed-products", "empty");
          this.onRender();
          return;
        }

        this.renderableList.forEach((product_handle, index) => {
          this.loadSingle(product_handle, index);
        });

        this.container.setAttribute("data-recently-viewed-products", "rendered");
      }

      renderSingle(product_data, index) {
        var product_renderable_wrapper = document.createElement("div");
        product_renderable_wrapper.setAttribute("data-order-index", index);
        product_renderable_wrapper.classList.add("productHistoryItem", "fi", "fi:1/2", "md-up:fi:1/4", "mb:st", "md-up:mb");
        product_renderable_wrapper.innerHTML = product_data;

        this.productOutput.appendChild(product_renderable_wrapper);
      }

      onRender() {
        if (this.externalConfig && typeof this.externalConfig.onRender === "function") {
          this.externalConfig.onRender();
        }
      }

      loadSingle(product_handle, index) {
        var endPoint = Shopify.routes.root + "products/" + product_handle + "?section_id=" + this.productCardSectionName;
        var renderSingle = this.renderSingle.bind(this);
        var removeFromList = this.viewedList.removeFromList.bind(this);

        WDN.Request.Get({
          url: endPoint,
          onSuccess: function (responseText) {
            var html = new DOMParser().parseFromString(responseText, "text/html");
            if (html.querySelector(".card--product").getAttribute("data-relative-product-url").length == 0) {
              return;
            }

            var item = html.querySelector(".shopify-section").innerHTML;

            renderSingle(item, index);

            // if forloop last
            if (this.renderableList.length - 1 === index) {
              this.onRender();
            }
          }.bind(this),
          onError: function (r) {
            removeFromList(product_handle);
          },
        });
      }

      start(externalConfig) {
        this.externalConfig = externalConfig;
        this.attachNodes();
        this.setupConfig();
        this.buildRenderableList();
        this.render();
        this.outputCount();
      }
    }

    return RenderViewedProducts;
  })();
}
